import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
  GetAdminTransactionsInputDto,
  GetAdminTransactionsOutputDto,
} from '../../../models/payment/dto/get-admin-transactions.dto';

export const GET_ADMIN_TRANSACTIONS_QUERY_KEY = 'admin-transactions';

export const useGetAdminTransactions = (
  params: GetAdminTransactionsInputDto,
) => {
  const client = useApiClient();

  return useQuery({
    queryKey: [GET_ADMIN_TRANSACTIONS_QUERY_KEY, params],
    queryFn: async () => {
      const queryParams = new URLSearchParams();
      queryParams.append('organizationId', params.organizationId);
      if (params.page != null)
        queryParams.append('page', params.page.toString());
      if (params.limit != null)
        queryParams.append('limit', params.limit.toString());
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.paymentMethod)
        queryParams.append('paymentMethod', params.paymentMethod);
      if (params.type) queryParams.append('type', params.type);
      if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
      if (params.dateTo) queryParams.append('dateTo', params.dateTo);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

      return client.fetchApi<GetAdminTransactionsOutputDto, {}>({
        endpoint: `payments/admin/transactions?${queryParams.toString()}`,
        method: 'GET',
      });
    },
    staleTime: 30 * 1000,
    cacheTime: 5 * 60 * 1000,
    keepPreviousData: true,
    enabled: Boolean(params.organizationId),
  });
};
